import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgLoading = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clip-rule="evenodd"
            d="M13.875 1.875C13.875 2.91051 13.0355 3.75 12 3.75C10.9645 3.75 10.125 2.91051 10.125 1.875C10.125 0.839493 10.9645 0 12 0C13.0355 0 13.875 0.839493 13.875 1.875ZM12 20.25C13.0355 20.25 13.875 21.0895 13.875 22.125C13.875 23.1605 13.0355 24 12 24C10.9645 24 10.125 23.1605 10.125 22.125C10.125 21.0895 10.9645 20.25 12 20.25ZM22.125 13.875C23.1605 13.875 24 13.0355 24 12C24 10.9645 23.1605 10.125 22.125 10.125C21.0895 10.125 20.25 10.9645 20.25 12C20.25 13.0355 21.0895 13.875 22.125 13.875ZM3.75 12C3.75 13.0355 2.91051 13.875 1.875 13.875C0.839493 13.875 0 13.0355 0 12C0 10.9645 0.839493 10.125 1.875 10.125C2.91051 10.125 3.75 10.9645 3.75 12ZM6.75 4.875C6.75 3.83945 5.91051 3 4.875 3C3.83949 3 3 3.83949 3 4.875C3 5.91051 3.83949 6.75 4.875 6.75C5.91051 6.75 6.75 5.91051 6.75 4.875ZM19.125 17.25C20.1606 17.25 21 18.0895 21 19.125C21 20.1605 20.1606 21 19.125 21C18.0895 21 17.25 20.1605 17.25 19.125C17.25 18.0895 18.0895 17.25 19.125 17.25ZM6.75 19.125C6.75 18.0895 5.91051 17.25 4.875 17.25C3.83949 17.25 3 18.0895 3 19.125C3 20.1605 3.83949 21 4.875 21C5.91051 21 6.75 20.1605 6.75 19.125Z"
            fill="current"
            fill-rule="evenodd"
        />
    </svg>
);

export const LoadingIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgLoading}
        fontSize={fontSize}
    />
);
